import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SgAsyncGuiPlugin, SgAsyncGuiOptions } from './types';
import { SgAsyncGuiPluginHost, SgAsyncGuiService, SG_ASYNC_GUI_DEFAULTS } from './async-gui.service';

@NgModule({
  imports: [CommonModule],
  // declarations: [ SgAsyncGuiDirective ],
  // exports: [ SgAsyncGuiDirective ]
})
export class SgAsyncGuiModule {
  static forRoot(defaultOptions: SgAsyncGuiOptions): ModuleWithProviders<SgAsyncGuiModule> {
    return {
      ngModule: SgAsyncGuiModule,
      providers: [
        { provide: SG_ASYNC_GUI_DEFAULTS, useValue: defaultOptions },
        SgAsyncGuiPluginHost,
        SgAsyncGuiService,
      ],
    };
  }
}
